/* WaterFun accessibility widget (2026-07-21).
 * Self-contained toolbar that lets visitors adapt the page. It is a
 * SUPPLEMENT to the site's own WCAG 2.0 AA conformance (IS 5568), not a
 * substitute for it.
 *
 * Accessibility of the widget itself: the trigger is a real <button>
 * with aria-expanded/aria-controls; the panel is role="dialog" with a
 * focus trap, Escape-to-close, and focus returned to the trigger on
 * close; every control is a real <button> with aria-pressed. Settings
 * persist in localStorage. Config comes from #wf-a11y-root data-* attrs
 * (set by snippets/waterfun-accessibility.liquid from the theme settings).
 */
(function () {
  'use strict';
  var root = document.getElementById('wf-a11y-root');
  if (!root || window.wfA11yInit) return;
  window.wfA11yInit = true;

  var STORAGE_KEY = 'wf_a11y_settings_v1';
  var position = root.dataset.position === 'bottom-right' ? 'bottom-right' : 'bottom-left';
  var statementUrl = root.dataset.statementUrl || '';

  var t = {
    open: 'פתיחת תפריט נגישות',
    title: 'התאמות נגישות',
    close: 'סגירה',
    fontSize: 'גודל טקסט',
    sizes: ['רגיל', 'גדול', 'גדול מאוד', 'ענק'],
    contrast: 'ניגודיות וצבע',
    contrastOpts: [
      { v: '', label: 'רגיל' },
      { v: 'high', label: 'ניגודיות גבוהה' },
      { v: 'dark', label: 'מצב כהה' },
      { v: 'grayscale', label: 'גווני אפור' }
    ],
    tools: 'כלים נוספים',
    reset: 'איפוס הגדרות נגישות',
    note: 'הרכיב מסייע בהתאמת התצוגה. להצהרת הנגישות המלאה:',
    noteLink: 'הצהרת נגישות',
    toggles: [
      { k: 'readableFont', label: 'פונט קריא' },
      { k: 'highlightLinks', label: 'הדגשת קישורים' },
      { k: 'highlightHeadings', label: 'הדגשת כותרות' },
      { k: 'letterSpacing', label: 'ריווח אותיות' },
      { k: 'lineHeight', label: 'ריווח שורות' },
      { k: 'bigCursor', label: 'סמן גדול' },
      { k: 'readingGuide', label: 'מדריך קריאה' },
      { k: 'stopAnim', label: 'עצירת אנימציות' },
      { k: 'focus', label: 'הדגשת מיקוד' }
    ]
  };

  var defaults = {
    fontSize: 0,
    contrast: '',
    readableFont: false,
    highlightLinks: false,
    highlightHeadings: false,
    letterSpacing: false,
    lineHeight: false,
    bigCursor: false,
    readingGuide: false,
    stopAnim: false,
    focus: false
  };

  var state = load();

  function load() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return Object.assign({}, defaults, JSON.parse(raw));
    } catch (e) {}
    return Object.assign({}, defaults);
  }
  function save() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  /* Apply the current state to the document (classes on <html>). */
  function apply() {
    var h = document.documentElement;
    h.classList.remove('wf-a11y-font-1', 'wf-a11y-font-2', 'wf-a11y-font-3');
    if (state.fontSize > 0) h.classList.add('wf-a11y-font-' + state.fontSize);

    h.classList.remove('wf-a11y-contrast-high', 'wf-a11y-contrast-dark', 'wf-a11y-grayscale');
    if (state.contrast === 'high') h.classList.add('wf-a11y-contrast-high');
    else if (state.contrast === 'dark') h.classList.add('wf-a11y-contrast-dark');
    else if (state.contrast === 'grayscale') h.classList.add('wf-a11y-grayscale');

    toggleClass(h, 'wf-a11y-readable-font', state.readableFont);
    toggleClass(h, 'wf-a11y-highlight-links', state.highlightLinks);
    toggleClass(h, 'wf-a11y-highlight-headings', state.highlightHeadings);
    toggleClass(h, 'wf-a11y-letter-spacing', state.letterSpacing);
    toggleClass(h, 'wf-a11y-line-height', state.lineHeight);
    toggleClass(h, 'wf-a11y-big-cursor', state.bigCursor);
    toggleClass(h, 'wf-a11y-stop-anim', state.stopAnim);
    toggleClass(h, 'wf-a11y-focus', state.focus);

    guide.style.display = state.readingGuide ? 'block' : 'none';
  }
  function toggleClass(el, cls, on) { el.classList.toggle(cls, !!on); }

  function svgNS(d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' + d + '</svg>';
  }

  /* ---- Build UI ---- */
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'wf-a11y-btn wf-a11y-btn--' + position;
  btn.id = 'wf-a11y-btn';
  btn.setAttribute('aria-label', t.open);
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-controls', 'wf-a11y-panel');
  btn.innerHTML = svgNS('<circle cx="12" cy="4" r="1.6"/><path d="M4 8h16M12 8v6m0 0l-3.2 6m3.2-6l3.2 6"/>');

  var guide = document.createElement('div');
  guide.className = 'wf-a11y-guide';
  guide.setAttribute('aria-hidden', 'true');

  var panel = document.createElement('div');
  panel.className = 'wf-a11y-panel wf-a11y-panel--' + position;
  panel.id = 'wf-a11y-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  panel.setAttribute('aria-label', t.title);
  panel.setAttribute('data-open', 'false');

  var html = '';
  html += '<div class="wf-a11y-panel__head">';
  html += '<h2 class="wf-a11y-panel__title">' + t.title + '</h2>';
  html += '<button type="button" class="wf-a11y-close" data-close aria-label="' + t.close + '">×</button>';
  html += '</div>';
  html += '<div class="wf-a11y-panel__body">';

  // font size segmented group
  html += '<div class="wf-a11y-group"><span class="wf-a11y-group__label" id="wf-a11y-fs-lbl">' + t.fontSize + '</span>';
  html += '<div class="wf-a11y-seg" role="group" aria-labelledby="wf-a11y-fs-lbl">';
  t.sizes.forEach(function (label, i) {
    html += '<button type="button" class="wf-a11y-seg__btn" data-font="' + i + '" aria-pressed="false">' + label + '</button>';
  });
  html += '</div></div>';

  // contrast segmented group
  html += '<div class="wf-a11y-group"><span class="wf-a11y-group__label" id="wf-a11y-ct-lbl">' + t.contrast + '</span>';
  html += '<div class="wf-a11y-seg" role="group" aria-labelledby="wf-a11y-ct-lbl">';
  t.contrastOpts.forEach(function (o) {
    html += '<button type="button" class="wf-a11y-seg__btn" data-contrast="' + o.v + '" aria-pressed="false">' + o.label + '</button>';
  });
  html += '</div></div>';

  // toggles
  html += '<div class="wf-a11y-group"><span class="wf-a11y-group__label" id="wf-a11y-tg-lbl">' + t.tools + '</span>';
  html += '<div class="wf-a11y-toggles" role="group" aria-labelledby="wf-a11y-tg-lbl">';
  t.toggles.forEach(function (o) {
    html += '<button type="button" class="wf-a11y-switch" data-toggle="' + o.k + '" aria-pressed="false">' +
      '<span>' + o.label + '</span><span class="wf-a11y-switch__track" aria-hidden="true"></span></button>';
  });
  html += '</div></div>';

  html += '</div>';
  html += '<div class="wf-a11y-panel__foot">';
  html += '<button type="button" class="wf-a11y-reset" data-reset>' + t.reset + '</button>';
  if (statementUrl) {
    html += '<p class="wf-a11y-note">' + t.note + ' <a href="' + statementUrl + '">' + t.noteLink + '</a></p>';
  }
  html += '</div>';
  panel.innerHTML = html;

  root.appendChild(btn);
  root.appendChild(panel);
  root.appendChild(guide);

  /* ---- Sync control states from `state` ---- */
  function sync() {
    panel.querySelectorAll('[data-font]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(Number(b.dataset.font) === state.fontSize));
    });
    panel.querySelectorAll('[data-contrast]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.contrast === state.contrast));
    });
    panel.querySelectorAll('[data-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(!!state[b.dataset.toggle]));
    });
  }

  /* ---- Events ---- */
  panel.addEventListener('click', function (e) {
    var el = e.target.closest('[data-font],[data-contrast],[data-toggle],[data-reset],[data-close]');
    if (!el) return;
    if (el.hasAttribute('data-close')) { close(); return; }
    if (el.hasAttribute('data-reset')) { state = Object.assign({}, defaults); apply(); sync(); save(); return; }
    if (el.hasAttribute('data-font')) { state.fontSize = Number(el.dataset.font); }
    else if (el.hasAttribute('data-contrast')) { state.contrast = el.dataset.contrast; }
    else if (el.hasAttribute('data-toggle')) { var k = el.dataset.toggle; state[k] = !state[k]; }
    apply(); sync(); save();
  });

  // reading guide follows the pointer
  document.addEventListener('mousemove', function (e) {
    if (state.readingGuide) guide.style.top = (e.clientY - 12) + 'px';
  });

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    panel.setAttribute('data-open', 'true');
    btn.setAttribute('aria-expanded', 'true');
    var first = panel.querySelector('button');
    if (first) first.focus();
    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('click', onOutside, true);
  }
  function close() {
    panel.setAttribute('data-open', 'false');
    btn.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown, true);
    document.removeEventListener('click', onOutside, true);
    if (lastFocus && lastFocus.focus) lastFocus.focus(); else btn.focus();
  }
  btn.addEventListener('click', function () {
    panel.getAttribute('data-open') === 'true' ? close() : open();
  });

  function onOutside(e) {
    if (!panel.contains(e.target) && e.target !== btn && !btn.contains(e.target)) close();
  }
  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    // focus trap inside the panel
    var f = panel.querySelectorAll('button, a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // initial paint
  apply();
  sync();
})();
